<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-alert
          v-if="isShowDowntimeAlert.isShow"
          type="warning"
          dense
          outlined
          dismissible
          icon="mdi-alert-outline"
          style="margin-bottom: 0"
          @input="alertDismiss()"
        >
          <!--eslint-disable vue/no-v-html-->
          <div
            style="white-space: pre-line"
            v-html="$i18n.locale === 'jp' ? isShowDowntimeAlert.message_jp : isShowDowntimeAlert.message_en"
          />
          <!--eslint-enable-->
        </v-alert>
      </v-col>
    </v-row>
    <v-row align="stretch">
      <v-col
        cols="12"
        md="8"
      >
        <v-card height="100%">
          <v-card-title>
            <div class="primary--text text-h5 my-2 title-bar">
              {{ $t('homepage.corporate_content') }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="6"
                xl="4"
                class="py-0 py-xl-1"
              >
                <div class="primary--text text-subtitle-1 font-weight-bold">
                  {{ $t('homepage.company_name') }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="8"
                class="py-0 py-xl-1"
              >
                <v-skeleton-loader
                  v-if="loading"
                  width="50%"
                  type="text"
                />
                <div
                  v-else
                  class="primary--text text-subtitle-1 font-weight-bold"
                >
                  : {{ companyInfo.name }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="4"
                class="py-0 py-xl-1"
              >
                <div class="primary--text text-subtitle-1 font-weight-bold">
                  {{ $t('homepage.membership_status') }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="8"
                class="py-0 py-xl-1"
              >
                <v-skeleton-loader
                  v-if="loading"
                  width="50%"
                  type="text"
                />
                <div
                  v-else
                  class="primary--text text-subtitle-1 font-weight-bold"
                >
                  : {{ companyInfo.membershipStatus }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="4"
                class="py-0 pr-0 py-xl-1"
              >
                <div class="primary--text text-subtitle-1 font-weight-bold">
                  {{ $t('homepage.employee_registration_status') }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="8"
                class="py-0 py-xl-1"
              >
                <v-skeleton-loader
                  v-if="loading"
                  width="50%"
                  type="text"
                />
                <div
                  v-else
                  class="primary--text text-subtitle-1 font-weight-bold"
                >
                  : {{ companyInfo.employeeStatus }} {{ $i18n.locale === 'jp' ? '名' : '' }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="4"
                class="py-0 py-xl-1"
              >
                <div class="primary--text text-subtitle-1 font-weight-bold">
                  {{ $t('homepage.membership_end_date') }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="8"
                class="py-0 py-xl-1"
              >
                <v-skeleton-loader
                  v-if="loading"
                  width="50%"
                  type="text"
                />
                <div
                  v-else
                  class="primary--text text-subtitle-1 font-weight-bold"
                >
                  : {{ companyInfo.endDate }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="4"
                class="pt-0 pb-2 pt-xl-1"
              >
                <div class="primary--text text-subtitle-1 font-weight-bold">
                  {{ $t('homepage.membership_renewal_date') }}
                </div>
              </v-col>
              <v-col
                cols="6"
                xl="8"
                class="pt-0 pb-2 pt-xl-1"
              >
                <v-skeleton-loader
                  v-if="loading"
                  width="50%"
                  type="text"
                />
                <div
                  v-else
                  class="primary--text text-subtitle-1 font-weight-bold"
                >
                  : {{ companyInfo.renewalDate }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-card
          height="100%"
          target="_blank"
          href="/manual/operationmanual.pdf"
        >
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  tile
                  block
                  color="red darken-1"
                  class="white--text"
                  :small="$vuetify.breakpoint.lgAndDown"
                >
                  {{ $t('homepage.for_first_time_customer') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="my-4">
              <v-col
                cols="8"
                sm="6"
                md="8"
                lg="8"
                offset="2"
                offset-sm="3"
                offset-md="2"
                offset-lg="2"
                class="text-center py-4 px-0"
              >
                <v-skeleton-loader
                  v-if="loading"
                  max-height="80px"
                  type="image"
                />
                <v-img
                  v-else
                  src="/img/quats-logo.png"
                />
              </v-col>
            </v-row>
            <div
              v-if="!loading"
              class="text-subtitle-1 font-weight-bold text-center black--text"
            >
              {{ $t('homepage.quat_user_guide') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <div class="primary--text text-h5 my-2 title-bar">
              {{ $t('program_list_table.available_list') }}
            </div>
          </v-card-title>
          <v-card-text>
            <ProgramListTable
              :programs="programs"
              :loading="loading"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="text-center"
      >
        <v-btn
          :to="{ name: 'EmployeeList' }"
          color="primary"
          :large="$vuetify.breakpoint.mdAndUp"
          :small="$vuetify.breakpoint.xs"
          :class="($vuetify.breakpoint.xs && $i18n.locale === 'en') ? 'btn-small-text' : ''"
          :loading="loading"
        >
          {{ $t('homepage.register_employee') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="!loading"
        cols="12"
        class="text-start font-weight-bold"
        style="display: block;"
      >
        {{ $t('homepage.membership_status_change') }}（
        <span
          class="link-button"
          @click="upgradeMembershipDialog = true"
        >
          {{ $t('homepage.upgrade_membership_button') }}
        </span>
        ／
        <span
          class="link-button"
          @click="downgradeSuspensionWithdrawalMembershipDialog = true"
        >
          {{ $t('homepage.downgrade_suspension_withdrawal_membership') }}
        </span>
        ）
      </v-col>
    </v-row>
    <v-dialog
      v-model="upgradeMembershipDialog"
      width="600px"
    >
      <v-card>
        <v-row
          no-gutters
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <v-card-title
              class="font-weight-bold"
              style="word-break: normal;"
            >
              {{ $t('homepage.upgrade_membership_category') }}
            </v-card-title>
            <v-card-text style="text-align: left">
              <div>
                <p>{{ $t('homepage.upgrade_membership_category_subtitle') }}</p>
                <ul class="no-bullets">
                  <li>◆{{ $t('homepage.upgrade_membership_category_heading_1') }}</li>
                  <li>
                    <p>{{ $t('homepage.upgrade_membership_category_heading_1_content_1') }}</p>
                    <p>※{{ $t('homepage.upgrade_membership_category_heading_1_content_2') }}</p>
                    <p>※{{ $t('homepage.upgrade_membership_category_heading_1_content_3') }}（<a href="https://achievement.co.jp/qcc/">https://achievement.co.jp/qcc/</a>）</p>
                  </li>
                  <li>◆{{ $t('homepage.upgrade_membership_category_heading_2') }}</li>
                  <li>
                    <p>{{ $t('homepage.upgrade_membership_category_heading_2_content_1') }}</p>
                    <p>※{{ $t('homepage.upgrade_membership_category_heading_2_content_2') }}</p>
                  </li>
                </ul>
                <v-btn
                  class="my-4 upgrade-membership-action-btn-width"
                  color="primary"
                  :small="$vuetify.breakpoint.lgAndDown"
                  :href="marcUpgradeMembershipURL"
                  target="_blank"
                >
                  <span class="upgrade-membership-action-button-text">{{ $t('homepage.upgrade_membership_category_action_btn') }}</span>
                </v-btn>
              </div>
              <div>
                <p style="margin-bottom: 4px">
                  ▼{{ $t('homepage.upgrade_membership_category_contact_us_msg') }}
                </p>
                <p style="margin-bottom: 4px">
                  <span style="font-weight: bold">MAIL：</span>qcc@achievement.co.jp
                </p>
                <p style="margin-bottom: 0">
                  <span style="font-weight: bold">TEL：</span>03-6858-3618
                </p>
              </div>
            </v-card-text>
          </v-col>
          <v-col
            cols="12"
            class="px-4 my-2 text-center"
          >
            <v-card-actions class="justify-center pa-0">
              <v-btn
                small
                block
                outlined
                @click="upgradeMembershipDialog = false"
              >
                {{ $t('homepage.close') }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="downgradeSuspensionWithdrawalMembershipDialog"
      width="600px"
    >
      <v-card>
        <v-row
          no-gutters
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <v-card-title
              class="font-weight-bold"
              style="word-break: normal"
            >
              {{ $t('homepage.downgrade_suspension_withdrawal_membership_category') }}
            </v-card-title>
            <v-card-text style="text-align: left">
              <div>
                <p>
                  {{ $t('homepage.downgrade_suspension_withdrawal_membership_category_subtitle_1') }}
                  <br> {{ $t('homepage.downgrade_suspension_withdrawal_membership_category_subtitle_2') }}
                  <br> {{ $t('homepage.downgrade_suspension_withdrawal_membership_category_subtitle_3') }}
                </p>
                <ul class="no-bullets">
                  <li>◆ {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_1') }} </li>
                  <li><p>{{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_1_content_1') }}</p></li>
                  <li>◆{{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_2') }}</li>
                  <li>
                    <p>
                      {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_2_content_1') }}
                      <br> {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_2_content_2') }}
                      <br> {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_2_content_3') }}
                    </p>
                  </li>
                  <li>◆{{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_3') }}</li>
                  <li>
                    <p>
                      {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_3_content_1') }}
                      <br> {{ $t('homepage.downgrade_suspension_withdrawal_membership_heading_3_content_2') }}
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p style="margin-bottom: 4px">
                  ▼{{ $t('homepage.downgrade_suspension_withdrawal_membership_contact_us_msg') }}
                </p>
                <p style="margin-bottom: 4px">
                  <span style="font-weight: bold">MAIL：</span>qcc@achievement.co.jp
                </p>
                <p style="margin-bottom: 0">
                  <span style="font-weight: bold">TEL：</span>03-6858-3618
                </p>
              </div>
            </v-card-text>
          </v-col>
          <v-col
            cols="12"
            class="px-4 my-2 text-center"
          >
            <v-card-actions class="justify-center pa-0">
              <v-btn
                small
                block
                outlined
                @click="downgradeSuspensionWithdrawalMembershipDialog = false"
              >
                {{ $t('homepage.close') }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ProgramListTable from '../../components/ProgramListTable'
import moment from 'moment-timezone'
import QUATSError from '../../plugins/error'

export default {
  components: { ProgramListTable },
  data () {
    return {
      loading: true,
      currentUser: {
        name: '',
        id: '',
        membershipCategoryId: '',
        membershipStatus: '',
        employeeStatus: '',
        programs: '',
        startDate: '',
        endDate: '',
        renewalDate: '',
        totalViewingRights: ''
      },
      programs: [],
      filteredMembershipPlans: [],
      upgradeMembershipDialog: false,
      downgradeSuspensionWithdrawalMembershipDialog: false,
      marcUpgradeMembershipURL: window.laravel.mix_marc_upgrade_membership_url
    }
  },
  computed: {
    isShowDowntimeAlert() {
      const downtime = JSON.parse(window.laravel.downtime_information)
      if (this.isShowDowntimePeriod(downtime.start_show, downtime.end)) {
        if (!sessionStorage.getItem('downtime')) {
          sessionStorage.setItem('downtime', 'true')
          downtime['isShow'] = true
        } else {
          downtime['isShow'] = sessionStorage.getItem('downtime') === 'true'
        }
      } else {
        downtime['isShow'] = false
      }
      return downtime
    },

    companyInfo() {
      return this.currentUser
    },

    /**
     * @desc Default Required Rule
     * */
    requiredRule() {
      return [
        v => !!v || this.$t('common.required')
      ]
    },
  },
  created() {
    if(this.$store.state.account.user) {
      this.initData()
    }
  },
  methods: {
    alertDismiss() {
      sessionStorage.setItem('downtime', 'false')
    },

    isShowDowntimePeriod(startShow, end) {
      moment.tz.setDefault('Asia/Tokyo')
      const now = moment()
      return now.isAfter(moment(startShow)) && now.isBefore(moment(end))
    },

    initData() {
      this.loading = true
      const promises = [
        window.axios.get('/api/home/parent-company'),
        window.axios.get('/api/home/corporate-account/quota'),
        window.axios.get('/api/home/membership'),
        window.axios.get('/api/home/membership/expiry'),
        window.axios.get('/api/home/quats-programs'),
        window.axios.get('/api/home/quats-programs/quota')
      ]
      return Promise.all(promises)
        .then(results => {
          this.setCompanyData(results[0].data.data.data, results[1].data.data.data, results[2].data.data.data, results[3].data.data.data)
          this.mergeProgramInfo(results[4].data.data.data, results[5].data.data.data.current)
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
        }).finally(() => {
          this.loading = false
        })
    },

    mergeProgramInfo(allPrograms, currentPrograms) {
      const programs = []
      currentPrograms.forEach((x) => {
        allPrograms.forEach((y) => {
          if (x.group_id === y.groupId) {
            x.title = y.title
            x.remaining_views = x.total_views - x.active_views
          }
        })
        programs.push(x)
      })
      this.programs = programs
    },

    setCompanyData(data, max, membership, expiryStatus) {
      const expiryDateTime = expiryStatus.update_term_date ? expiryStatus.update_term_date.split(' ') : ''
      const time = expiryDateTime ? expiryDateTime[1].slice(0,5) : ''
      this.currentUser.name = data.name
      this.currentUser.id = data.id
      this.currentUser.membershipCategoryId = membership.membership_id
      this.currentUser.membershipStatus = this.onRemoveText(membership.membership_division_value_name)
      this.currentUser.employeeStatus = `${max.total - max.active} / ${max.total}`
      this.currentUser.startDate = expiryStatus.start_ym ? expiryStatus.start_ym : 'N/A'
      this.currentUser.endDate = expiryStatus.end_term_date ? expiryStatus.end_term_date : 'N/A'
      this.currentUser.renewalDate = `${expiryDateTime[0] ? expiryDateTime[0] : 'N/A'} ${time}`
      this.currentUser.totalViewingRights = max.total
      this.filteredMembershipPlans = max.plans.filter(x => x.max < max.total)
    },

    onRemoveText(data) {
      return data.replace(data.substring(data.indexOf('('), data.indexOf(')')+1), '')
    },

    timestampToDate(ts, tz, format='YYYY-MM-DD hh:mmA') {
      if(ts !== null) {
        ts = typeof ts === 'number' ? ts : parseInt(ts)
        return moment.unix(ts).tz(tz).format(format)
      } else {
        return ''
      }
    },

    generateMembershipNameForMail(membershipName, viewingRights) {
      return membershipName + ' (' + viewingRights + '人まで)'
    }
  }
}
</script>

<style scoped>
.title-bar:after {
  content:' ';
  display:block;
  border:2px solid #072a67;
}
.btn-small-text {
  font-size: 0.6rem;
}
.no-bullets {
  list-style-type: none;
  padding: 0;
}
.upgrade-membership-action-btn-width {
  width: 100%;
  height: 38px !important;
}
.upgrade-membership-action-button-text {
  font-size: 14px;
}

.link-button {
  color: #4444ea;
  cursor: pointer;
  text-decoration: underline;
  margin: 0 5px;
}
</style>
